import { createFileRoute } from '@tanstack/react-router'
import { ListingsPage } from '../../../components/listings/ListingsPage'

export type ListingStatusFilter = 'draft' | 'published' | 'paused' | 'let' | 'withdrawn'
const STATUSES: ListingStatusFilter[] = ['draft', 'published', 'paused', 'let', 'withdrawn']

/** The rental listings (spec 2026-10-25-10). The filters live in the URL. */
export const Route = createFileRoute('/$org/listings/')({
  component: ListingsPage,
  validateSearch: (search: Record<string, unknown>) => ({
    status: STATUSES.find((s) => s === search.status),
    asset: search.asset ? String(search.asset) : undefined,
  }),
})
